var exports = {
  "SF": "AutocompleteEmoji.module__sectionHeading___a2pOYV",
  "yF": "AutocompleteEmoji.module__divider___a2pOYV",
  "mI": "AutocompleteEmoji.module__emojiIcon___a2pOYV",
  "M9": "AutocompleteEmoji.module__stickerIconWrapper___a2pOYV",
  "F1": "AutocompleteEmoji.module__memeIconWrapper___a2pOYV",
  "lA": "AutocompleteEmoji.module__stickerIcon___a2pOYV",
  "Cu": "AutocompleteEmoji.module__memeIcon___a2pOYV",
  "_Q": "AutocompleteEmoji.module__memeVideo___a2pOYV",
  "BN": "AutocompleteEmoji.module__audioIconWrapper___a2pOYV",
  "iw": "AutocompleteEmoji.module__audioIcon___a2pOYV",
};

module.exports = exports;
